import { useTranslation } from 'react-i18next';
import styles from './ProjectDashboard.module.scss';
import { Button, Space, Tooltip } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { ColorMarker } from '@/components';

export const colorMap = {
  green: '#C1E999',
  blue: '#9DC8FB',
  orange: '#F6C277',
  yellow: '#FBE69A',
  red: '#F2A7A0',
  gray: '#D7D7D7',
};

const TooltipContent = () => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'projects.dashboard.legend',
  });

  return (
    <Space direction="vertical" size="middle">
      <Space>
        <ColorMarker color={colorMap['green']} /> {t('green')}
      </Space>
      <Space>
        <ColorMarker color={colorMap['blue']} /> {t('blue')}
      </Space>
      <Space>
        <ColorMarker color={colorMap['orange']} /> {t('orange')}
      </Space>
      <Space>
        <ColorMarker color={colorMap['yellow']} /> {t('yellow')}
      </Space>
      <Space>
        <ColorMarker color={colorMap['red']} /> {t('red')}
      </Space>
      <Space>
        <ColorMarker color={colorMap['gray']} /> {t('gray')}
      </Space>
    </Space>
  );
};

export const ProjectDashboardLegend = () => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.dashboard' });

  return (
    <Tooltip
      overlayInnerStyle={{
        borderRadius: '1rem',
        padding: '1.5rem',
        minWidth: '300px',
      }}
      placement="leftBottom"
      title={<TooltipContent />}
    >
      <Button
        className={styles.link}
        type="link"
        icon={<ExclamationCircleOutlined />}
      >
        {t('legend.title')}
      </Button>
    </Tooltip>
  );
};
